// ProductDetail.jsx
import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Header from '../../includes/Header';
import Footer from '../../includes/Footer';
import ProductCard from '../../components/ProductCard/ProductCard';
import Loader from '../../components/Loader/Loader';
import { postProductDetails, AddWishlist, RemoveWishlist, postStoreCart } from '../../apiservices/ApiServices';
import { ToastContainer, toast } from 'react-toastify';
import { IoMdHeartEmpty, IoMdHeart } from "react-icons/io";
import { FaStar, FaStarHalfAlt, FaBolt, FaRegShareSquare } from "react-icons/fa";
import { FacebookShareButton, WhatsappShareButton } from "react-share";
import { FaFacebookF, FaXTwitter, FaWhatsapp, FaLink } from "react-icons/fa6";
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/thumbs';
import 'swiper/css/navigation';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Thumbs, Pagination, Scrollbar, A11y } from 'swiper/modules';
import { useCartWishlist } from '../CartWishlistContext';

const ProductDetail = () => {
    const location = useLocation();
    const pathname = location.pathname;
    const search = location.search;
    const [showModal, setShowModal] = useState(false);
    const slug = pathname.split("/").pop() + search;
    const navigate = useNavigate();
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const [quantity, setQuantity] = useState(1);
    const [isLoading, setLoading] = useState(true);
    const [isLoadings, setLoadings] = useState(false);
    const [data, setData] = useState([]);
    const [relatedPro, setRelatedPro] = useState([]);
    const [reviews, setReviews] = useState([]);
    const [msg, setMsg] = useState('');
    const [ismsg, setisMsg] = useState(false);
    const [isShare, setIsShare] = useState(false);

    const [selectedValues, setSelectedValues] = useState({});
    const [isCarts, setCarts] = useState(false);
    const [show, setShow] = useState(false);
    const [review, setReview] = useState([]);
    const [wishlistsTot, setWishlistsTot] = useState(1);
    const [selectedBrandId, setSelectedBrandId] = useState("");
    const [selectedModelId, setSelectedModelId] = useState("");
    const [activeTab, setActiveTab] = useState('description');
    const shareUrl = window.location.href;
    const { cart, setCart, isCart, setIsCart, wishlist, isLogin, setIsLogin, addToCart, toggleWishlist } = useCartWishlist();

    useEffect(() => {
        if (localStorage.getItem('userToken')) {
            setIsLogin(true);
        } else {
            setIsLogin(false);
        }
    }, []);


    useEffect(() => {
        const cartdata = cart.some(item => item.sku_id == data?.records?.sku_id);
        if (cartdata) {
            setCarts(false)
        } else {
            setCarts(true)
        }
    }, [cart, data]);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    const handleRadioChange = async (attributeName, valueId) => {
        setSelectedValues((prev) => ({ ...prev, [attributeName]: valueId }));
        setQuantity(1);
        const formData = new FormData();
        formData.append("product_slug", slug || "");
        formData.append("attribute_value_id[]", valueId);
        setLoadings(true);
        try {
            const res = await postProductDetails(formData);
            setData(res.data.data);
            setRelatedPro(res.data.data.related_product);
            scrollToTop();
            setLoadings(false);

            const storedCart = JSON.parse(localStorage.getItem('cart')) || [];
            setCart(storedCart);

            const productInCart = storedCart.some(item => item.sku_id == res.data.data.records.sku_id);
            if (productInCart) {
                setCarts(false)
            } else {
                setCarts(true)
            }

        } catch (error) {
            setLoadings(false);
            setisMsg(true);
            setMsg(error.response?.data?.message || "Something went wrong");
        }
    };

    const handleBrandChange = (e) => {
        const brandId = Number(e.target.value);
        setSelectedBrandId(brandId);

        if (!brandId) {
            setSelectedModelId("");
            return;
        }

        const selectedBrand = data.filter_brand.find(b => b.id === brandId);
        const firstModel = selectedBrand?.models?.[0];

        if (firstModel) {
            setSelectedModelId(firstModel.model_id);
            handleModelChange({ target: { value: firstModel.model_id } });
        }
    };

    const handleModelChange = async (e) => {
        const modelId = e.target.value;
        setSelectedModelId(modelId);

        if (!modelId) return;

        setQuantity(1);
        const formData = new FormData();
        formData.append("product_slug", slug || "");
        formData.append("model_id[]", modelId);

        setLoadings(true);
        try {
            const res = await postProductDetails(formData);
            setData(res.data.data);
            setRelatedPro(res.data.data.related_product);
            scrollToTop();

            const storedCart = JSON.parse(localStorage.getItem("cart")) || [];

            setCart(storedCart);
            const productInCart = storedCart.some(item => item.sku_id == res.data.data.records.sku_id);
            setCarts(!productInCart);
        } catch (error) {
            setisMsg(true);
            setMsg(error.response?.data?.message || "Something went wrong");
        } finally {
            setLoadings(false);
        }
    };

    const handleIncrement = () => {
        if (quantity < data.records.quantity) {
            setQuantity(prev => prev + 1);
        } else {
            toast.info(`Maximum ${data.records.quantity} Quantity Reached`);
        }
    };

    const handleDecrement = () => {
        if (quantity > 1) {
            setQuantity(prev => (prev > 1 ? prev - 1 : 1));
        } else {
            toast.info('Minimum Quantity Reached');
        }
    };

    const handleChange = (e) => {
        const value = parseInt(e.target.value, 10);
        if (!isNaN(value) && value > 0) {
            setQuantity(value);
        } else {
            setQuantity(1);
        }
    };

    const postProDetail = async (postdata) => {
        try {
            const res = await postProductDetails(postdata);
            setData(res.data.data);
            setRelatedPro(res.data.data.related_product);
            setReviews(res.data.data.records.order_review);
            setisMsg(false);
            setLoading(false);

            const storedCart = JSON.parse(localStorage.getItem('cart')) || [];

            setCart(storedCart);
            const productInCart = storedCart.some(item => item.sku_id == res.data.data.records.sku_id);
            if (productInCart) {
                setCarts(false)
            } else {
                setCarts(true)
            }

        } catch (error) {
            setLoading(false);
            setisMsg(true);
            setMsg(error.response.data.message);
        }
    };

    useEffect(() => {
        setLoading(true);
        setThumbsSwiper(null);
        setQuantity(1)

        let postdata = {
            "product_slug": slug,
        }
        postProDetail(postdata);
    }, [slug])

    useEffect(() => {
        if (data?.filter_brand?.length > 0) {
            for (const brand of data.filter_brand) {
                const selectedModel = brand.models.find(model => model.isSelected === 1);
                if (selectedModel) {
                    setSelectedBrandId(brand.id);
                    setSelectedModelId(selectedModel.model_id);
                    break;
                }
            }
        }
    }, [data]);

    const postCartData = async (postdata) => {
        try {
            const res = await postStoreCart([postdata]);
            const updatedCart = [...cart, postdata];
            localStorage.setItem('cart', JSON.stringify(updatedCart));
            setCart(updatedCart);
            window.dispatchEvent(new Event("storage"));
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message);
        }
    };



    const postCartDatas = async (postdata) => {
        try {
            const res = await postStoreCart([postdata]);
            const updatedCart = [...cart, postdata];
            localStorage.setItem('cart', JSON.stringify(updatedCart));
            setCart(updatedCart);
            const productInCart = updatedCart.some(item => item.sku_id == data.records.sku_id);
            if (productInCart) {
                setCarts(false)
            } else {
                setCarts(true)
            }
            window.dispatchEvent(new Event("storage"));
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message);
        }
    };

    const addToCarts = () => {
        if (localStorage.getItem('userToken')) {
            const newProduct = {
                sku_id: data.records.sku_id,
                quantity: quantity,
            };
            postCartDatas(newProduct);
        } else {
            const newProduct = {
                sku_id: data.records.sku_id,
                quantity: quantity,
            };
            const updatedCart = [...cart, newProduct];
            localStorage.setItem('cart', JSON.stringify(updatedCart));
            setCart(updatedCart);
            const productInCart = updatedCart.some(item => item.sku_id == data.records.sku_id);
            if (productInCart) {
                setCarts(false)
            } else {
                setCarts(true)
            }
            window.dispatchEvent(new Event("storage"));
        }
    };

    const addToWishlist = async (skuid) => {
        const postdata = {
            sku_id: skuid,
        };
        try {
            const res = await AddWishlist(postdata);
            if (data.records.sku_id == skuid) {
                setData((prevData) => {
                    if (!prevData.records) return prevData;
                    return {
                        ...prevData,
                        records: {
                            ...prevData.records,
                            is_wishlist: prevData.records.sku_id === skuid ? true : prevData.records.is_wishlist,
                        },
                    };
                });
            } else {
                const updatedProducts = relatedPro.map(product =>
                    product.sku_id === skuid ? { ...product, is_wishlist: true } : product
                );
                setRelatedPro(updatedProducts);
            }
            setWishlistsTot(wishlistsTot + 1);
        } catch (error) {
            console.log(error);
        }
    };

    const removeWishlist = async (skuid) => {
        try {
            const res = await RemoveWishlist(skuid);
            if (data.records.sku_id == skuid) {
                setData((prevData) => {
                    if (!prevData.records) return prevData;
                    return {
                        ...prevData,
                        records: {
                            ...prevData.records,
                            is_wishlist: prevData.records.sku_id === skuid ? false : prevData.records.is_wishlist,
                        },
                    };
                });
            } else {
                const updatedProducts = relatedPro.map(product =>
                    product.sku_id === skuid ? { ...product, is_wishlist: false } : product
                );
                setRelatedPro(updatedProducts);
            }
            setWishlistsTot(wishlistsTot + 1);
        } catch (error) {
            console.log(error);
        }
    };

    const handleClose = () => {
        setShow(false);
        setReview([]);
    };

    const handleShow = (item) => {
        setShow(true);
        setReview(item);
    };

    const buyNow = () => {
        let buyData = {
            "sku_id": data?.records?.sku_id,
            "quantity": quantity
        }
        localStorage.setItem('BuyNowData', JSON.stringify(buyData));
        if (localStorage.getItem('userToken')) {
            navigate("/checkout");
        } else {
            localStorage.setItem('isProceedCheckout', true);
            setShowModal(true);
        }
    };

    const handleCopyLink = async () => {
        try {
            await navigator.clipboard.writeText(shareUrl);
            alert("Link copied!");
            setIsShare(false);
        } catch (error) {
            console.error("Failed to copy link:", error);
        }
    };

    return (
        <>
            <Header CartTot={cart.length} WishTot={wishlistsTot} toast={toast} showModal={showModal} setShowModal={setShowModal} />
            <ToastContainer />
            {isLoading ? (<Loader />) : (
                <>
                    <div className="crumbsec">
                        <div className="wrap">
                            <Link to={'/'}>Home</Link>
                            <span className="sep">&rsaquo;</span>
                            <Link to={'/categories'}>Categories</Link>
                            <span className="sep">&rsaquo;</span>
                            <span className="cur">Product Detail</span>
                        </div>
                    </div>

                    {ismsg ?
                        <div className='nodata details'>
                            <h2>{msg}</h2>
                            <div className='buttonbox'>
                                <Link className='btn btn-green' to={'/product'}>Back to shopping</Link>
                            </div>
                        </div>
                        :
                        <>
                            <section id="prodetails" className="product-detail-section">
                                <div className="prodetails-block">
                                    <div className='shareboxs'>
                                        <div className='sharebuttons'>
                                            <button type='button' onClick={() => setIsShare(!isShare)}><FaRegShareSquare /></button>
                                        </div>
                                        {isShare && (
                                            <ul className="share-buttons">
                                                <li>
                                                    <WhatsappShareButton className='sharebuttons' onClick={() => setIsShare(!isShare)} url={shareUrl} title={data?.records?.name}>
                                                        <FaWhatsapp /> WhatsApp
                                                    </WhatsappShareButton>
                                                </li>
                                                <li>
                                                    <FacebookShareButton className='sharebuttons' onClick={() => setIsShare(!isShare)} url={shareUrl} quote={data?.records?.name}>
                                                        <FaFacebookF /> Facebook
                                                    </FacebookShareButton>
                                                </li>
                                                <li>
                                                    <button type="button" className='sharebuttons'
                                                        onClick={() => {
                                                            window.open(
                                                                `https://twitter.com/intent/tweet?url=${encodeURIComponent(
                                                                    shareUrl
                                                                )}&text=${encodeURIComponent(data?.records?.name || "")}`,
                                                                "_blank"
                                                            );
                                                        }}
                                                    >
                                                        <FaXTwitter /> Twitter
                                                    </button>
                                                </li>
                                                <li>
                                                    <button
                                                        type="button"
                                                        onClick={handleCopyLink}
                                                        className='sharebuttons'
                                                        title="Copy link"
                                                    >
                                                        <FaLink /> Copy Link
                                                    </button>
                                                </li>
                                            </ul>
                                        )}
                                    </div>
                                    <Container>
                                        <div className="prodetails-box">
                                            <Row>
                                                <Col md={4}>
                                                    <div className="prodetails-slide">
                                                        <Swiper
                                                            spaceBetween={10}
                                                            navigation
                                                            thumbs={{ swiper: thumbsSwiper && thumbsSwiper.el ? thumbsSwiper : null }}
                                                            pagination={{ clickable: true }}
                                                            scrollbar={{ draggable: true }}
                                                            modules={[Thumbs, Navigation, Pagination, Scrollbar, A11y]}
                                                            className="main-swiper"
                                                        >
                                                            {data.records.media_list.map((item, index) => (
                                                                <SwiperSlide key={`main-${index}`}>
                                                                    {item.media_type === "video" ? (
                                                                        <div className='video-slide'>
                                                                            <iframe src={item?.video_url} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                                                                        </div>
                                                                    ) : (
                                                                        <img src={item?.media_url} alt={`main-${index}`} />
                                                                    )}
                                                                </SwiperSlide>
                                                            ))}
                                                        </Swiper>
                                                        <Swiper
                                                            onSwiper={setThumbsSwiper}
                                                            spaceBetween={6}
                                                            slidesPerView={6}
                                                            freeMode
                                                            watchSlidesProgress
                                                            modules={[Thumbs, Navigation]}
                                                            className="thumb-swiper"
                                                        >
                                                            {data.records.media_list.map((item, index) => (
                                                                <SwiperSlide key={`thumb-${index}`}>
                                                                    <img src={item?.media_url} alt={`thumb-${index}`} />
                                                                </SwiperSlide>
                                                            ))}
                                                        </Swiper>
                                                    </div>
                                                </Col>
                                                <Col md={8}>
                                                    <div className="product-info">
                                                        <div className="protitle">
                                                            <h1 className="product-name">{data.records.name.toLowerCase()}</h1>
                                                            <div className="priceboxs">
                                                                <div className="prices">
                                                                    <span className="pprice">₹{data.records.price}</span>
                                                                    <span className="pold">₹{data.records.actual_price}</span>
                                                                </div>
                                                                <div className="best-seller-badge">
                                                                    <FaBolt className="bolt-icon" />
                                                                    Best Seller
                                                                </div>
                                                                {/* {data?.records?.discount_per != '' && (
                                                                    <div className="offer">
                                                                        <p>{`${data?.records?.discount_per}% OFF`}</p>
                                                                    </div>
                                                                )} */}
                                                            </div>
                                                            <div className="taxes-note">Inclusive of all taxes</div>
                                                        </div>

                                                        <div className='procontnt' dangerouslySetInnerHTML={{ __html: data?.records?.short_description }}>
                                                        </div>

                                                        {data?.filter_brand?.length > 0 && (
                                                            <>
                                                                <div className="changedevices">
                                                                    <h5>Select Brand :</h5>
                                                                    <select
                                                                        className="custom-select"
                                                                        value={selectedBrandId}
                                                                        onChange={handleBrandChange}
                                                                    >
                                                                        <option value="">Select Brand</option>
                                                                        {data.filter_brand.map((item) => (
                                                                            <option key={item.id} value={item.id}>
                                                                                {item.name}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                                <div className='changedevices'>
                                                                    <h5>Select Model :</h5>
                                                                    <select
                                                                        className="custom-select"
                                                                        value={selectedModelId}
                                                                        onChange={handleModelChange}
                                                                        disabled={!selectedBrandId}
                                                                    >
                                                                        <option value="">Select Model</option>
                                                                        {data.filter_brand
                                                                            .find(b => b.id === selectedBrandId)
                                                                            ?.models.map(model => (
                                                                                <option key={model.model_id} value={model.model_id}>
                                                                                    {model.name}
                                                                                </option>
                                                                            ))}
                                                                    </select>
                                                                </div>
                                                            </>
                                                        )}
                                                        <div className="subinfo">
                                                            {data.filter_attributes.map((item) => (
                                                                <>
                                                                    {item.name == 'Colour' ? (
                                                                        <>
                                                                            {item?.values?.length > 1 && (
                                                                                <div className="colorList size" key={`attr_${item.name}`}>
                                                                                    <ul>
                                                                                        <li><h6>{item.name} :</h6></li>
                                                                                    </ul>
                                                                                    <Swiper
                                                                                        spaceBetween={8}
                                                                                        slidesPerView={5}
                                                                                        navigation
                                                                                        className="thumb-swipers"
                                                                                        pagination={{ clickable: true }}
                                                                                        scrollbar={{ draggable: true }}
                                                                                        modules={[Thumbs, Navigation, Scrollbar, A11y]}
                                                                                        breakpoints={{
                                                                                            1200: { slidesPerView: 6 },
                                                                                            1024: { slidesPerView: 4 },
                                                                                            768: { slidesPerView: 4 },
                                                                                            640: { slidesPerView: 3 },
                                                                                            401: { slidesPerView: 3 },
                                                                                            300: { slidesPerView: 2 },
                                                                                        }}
                                                                                    >
                                                                                        {item.values.map((value, inx) => (
                                                                                            <SwiperSlide key={`${item.name}_${value.id}_${inx}`}>
                                                                                                <div className="colorsBoxs">
                                                                                                    <input
                                                                                                        type="radio"
                                                                                                        id={value.id}
                                                                                                        name={item.name}
                                                                                                        value={value.id}
                                                                                                        checked={selectedValues[item.name] === value.id || value.isSelected === 1 ? true : false}
                                                                                                        onChange={() => handleRadioChange(item.name, value.id)}
                                                                                                    />
                                                                                                    <div className='colorboxs'>
                                                                                                        <div className='crdimgs'>
                                                                                                            <img src={value.default_image} alt='Colour' title='Colour' />
                                                                                                        </div>
                                                                                                        <div className='crdContent'>
                                                                                                            <label htmlFor={value.id}>{value.title}</label>
                                                                                                            <div className='slideprices'>
                                                                                                                <span className="pprices">&#8377;{value.price}</span>
                                                                                                                <span className="polds">&#8377;{value.actual_price}</span>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </SwiperSlide>
                                                                                        ))}
                                                                                    </Swiper>
                                                                                </div>
                                                                            )}
                                                                        </>
                                                                    ) : (null
                                                                        // <ul className="size" key={`attr_${item.name}`}>
                                                                        //     <li><h6>{item.name} :</h6></li>
                                                                        //     {item.values.map((value, inx) => (
                                                                        //         <li key={`${item.name}_${value.id}_${inx}`}>
                                                                        //             <div className="rdobox">
                                                                        //                 <input
                                                                        //                     type="radio"
                                                                        //                     id={value.id}
                                                                        //                     name={item.name}
                                                                        //                     value={value.id}
                                                                        //                     checked={selectedValues[item.name] === value.id || value.isSelected === 1 ? true : false}
                                                                        //                     onChange={() => handleRadioChange(item.name, value.id)}
                                                                        //                 />
                                                                        //                 <label htmlFor={value.id}>{value.title}</label>
                                                                        //             </div>
                                                                        //         </li>
                                                                        //     ))}
                                                                        // </ul>
                                                                    )}
                                                                </>
                                                            ))}
                                                        </div>

                                                        {/* Quantity & Cart */}
                                                        <div className='qty-cartbox'>
                                                            {data.records.quantity == 0 ? (
                                                                <div className='outofstock'>Out of Stock</div>
                                                            ) : (
                                                                <>
                                                                    <h6>Quantity :</h6>
                                                                    <div className='qtybox'>
                                                                        <button className='minus' onClick={handleDecrement}>−</button>
                                                                        <input
                                                                            type="number"
                                                                            value={quantity}
                                                                            onChange={handleChange}
                                                                            min="1"
                                                                        />
                                                                        <button className='plush' onClick={handleIncrement}>+</button>
                                                                    </div>
                                                                </>
                                                            )}
                                                            {isLogin && (
                                                                <div className='whishlist'>
                                                                    {data.records.is_wishlist ? (
                                                                        <button className='btn btn-wishlist active' onClick={() => removeWishlist(data.records.sku_id)}>
                                                                            <IoMdHeart />
                                                                        </button>
                                                                    ) : (
                                                                        <button className='btn btn-wishlist' onClick={() => addToWishlist(data.records.sku_id)}>
                                                                            <IoMdHeartEmpty />
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>

                                                        {data.records.quantity != 0 && data.records.quantity <= 3 && (
                                                            <div className='best-seller-badges'>⚠️ Only {data.records.quantity} items left. Order now! </div>
                                                        )}

                                                        <div className='buttonGrids'>
                                                            {isCarts ? (
                                                                <button onClick={addToCarts} className='btn btn-green btn-add-cart'>ADD TO CART</button>
                                                            ) : (
                                                                <button className='btn btn-green btn-add-cart' onClick={() => setIsCart(!isCart)}>GO TO CART</button>
                                                            )}
                                                            {data.records.quantity != 0 && (
                                                                <button onClick={buyNow} className='btn btn-green btn-buy-now'>BUY IT NOW</button>
                                                            )}
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>

                                            <div className='productscontents'>
                                                <Tabs
                                                    defaultActiveKey="description"
                                                    id="product-tabs"
                                                    className="product-tabs"
                                                    activeKey={activeTab}
                                                    onSelect={(k) => setActiveTab(k)}
                                                >
                                                    <Tab eventKey="description" title="DESCRIPTION">
                                                        <h4>About Product</h4>
                                                        <div dangerouslySetInnerHTML={{ __html: data.records.description }}></div>
                                                    </Tab>
                                                    <Tab eventKey="productdetails" title="FEATURES">
                                                        <h4>Product Details</h4>
                                                        <div dangerouslySetInnerHTML={{ __html: data.records.product_details }}></div>
                                                    </Tab>
                                                    {reviews.length > 0 && (
                                                        <Tab eventKey="reviews" title={`REVIEWS (${reviews?.meta?.total || 0})`}>
                                                            <div className='titlesboxs'>
                                                                <img src={reviews?.meta?.image_url || ''} alt='' title='' />
                                                                <div className='rating'>
                                                                    {reviews?.meta?.average == 5 && (
                                                                        <ul>
                                                                            <li><FaStar /></li><li><FaStar /></li><li><FaStar /></li><li><FaStar /></li><li><FaStar /></li>
                                                                            <li><p>({reviews?.meta?.total})</p></li>
                                                                        </ul>
                                                                    )}
                                                                    {reviews?.meta?.average == 4.5 && (
                                                                        <ul>
                                                                            <li><FaStar /></li><li><FaStar /></li><li><FaStar /></li><li><FaStar /></li><li><FaStarHalfAlt /></li>
                                                                            <li><p>({reviews?.meta?.total})</p></li>
                                                                        </ul>
                                                                    )}
                                                                    {reviews?.meta?.average == 4 && (
                                                                        <ul>
                                                                            <li><FaStar /></li><li><FaStar /></li><li><FaStar /></li><li><FaStar /></li>
                                                                            <li><FaStar style={{ color: '#ccc' }} /></li>
                                                                            <li><p>({reviews?.meta?.total})</p></li>
                                                                        </ul>
                                                                    )}
                                                                    {reviews?.meta?.average == 3.5 && (
                                                                        <ul>
                                                                            <li><FaStar /></li><li><FaStar /></li><li><FaStar /></li><li><FaStarHalfAlt /></li>
                                                                            <li><FaStar style={{ color: '#ccc' }} /></li>
                                                                            <li><p>({reviews?.meta?.total})</p></li>
                                                                        </ul>
                                                                    )}
                                                                    {reviews?.meta?.average == 3 && (
                                                                        <ul>
                                                                            <li><FaStar /></li><li><FaStar /></li><li><FaStar /></li>
                                                                            <li><FaStar style={{ color: '#ccc' }} /></li>
                                                                            <li><FaStar style={{ color: '#ccc' }} /></li>
                                                                            <li><p>({reviews?.meta?.total})</p></li>
                                                                        </ul>
                                                                    )}
                                                                    {reviews?.meta?.average == 2.5 && (
                                                                        <ul>
                                                                            <li><FaStar /></li><li><FaStar /></li><li><FaStarHalfAlt /></li>
                                                                            <li><FaStar style={{ color: '#ccc' }} /></li>
                                                                            <li><FaStar style={{ color: '#ccc' }} /></li>
                                                                            <li><p>({reviews?.meta?.total})</p></li>
                                                                        </ul>
                                                                    )}
                                                                    {reviews?.meta?.average == 2 && (
                                                                        <ul>
                                                                            <li><FaStar /></li><li><FaStar /></li>
                                                                            <li><FaStar style={{ color: '#ccc' }} /></li>
                                                                            <li><FaStar style={{ color: '#ccc' }} /></li>
                                                                            <li><FaStar style={{ color: '#ccc' }} /></li>
                                                                            <li><p>({reviews?.meta?.total})</p></li>
                                                                        </ul>
                                                                    )}
                                                                    {reviews?.meta?.average == 1.5 && (
                                                                        <ul>
                                                                            <li><FaStar /></li><li><FaStarHalfAlt /></li>
                                                                            <li><FaStar style={{ color: '#ccc' }} /></li>
                                                                            <li><FaStar style={{ color: '#ccc' }} /></li>
                                                                            <li><FaStar style={{ color: '#ccc' }} /></li>
                                                                            <li><p>({reviews?.meta?.total})</p></li>
                                                                        </ul>
                                                                    )}
                                                                    {reviews?.meta?.average == 1 && (
                                                                        <ul>
                                                                            <li><FaStar /></li>
                                                                            <li><FaStar style={{ color: '#ccc' }} /></li>
                                                                            <li><FaStar style={{ color: '#ccc' }} /></li>
                                                                            <li><FaStar style={{ color: '#ccc' }} /></li>
                                                                            <li><FaStar style={{ color: '#ccc' }} /></li>
                                                                            <li><p>({reviews?.meta?.total})</p></li>
                                                                        </ul>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className='reviewsList'>
                                                                <Row>
                                                                    {reviews?.list.map((item, index) => (
                                                                        <Col md={6} key={`reviews_${index}`}>
                                                                            <div className='reviewsboxs'>
                                                                                <div className='reviewshed'>
                                                                                    <div className='userio'>
                                                                                        <img src={item.image_url} alt='' title='' />
                                                                                    </div>
                                                                                    <div className='username'>
                                                                                        <h4>{item.customer_name}</h4>
                                                                                        <p>{item.review_date}</p>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="reviewsbody">
                                                                                    <div className='rating'>
                                                                                        {[...Array(5)].map((_, i) => {
                                                                                            const starVal = i + 1;
                                                                                            if (starVal <= Math.floor(item.rating)) return <FaStar key={i} />;
                                                                                            if (starVal === Math.ceil(item.rating) && item.rating % 1 !== 0) return <FaStarHalfAlt key={i} />;
                                                                                            return <FaStar key={i} style={{ color: '#ccc' }} />;
                                                                                        })}
                                                                                    </div>
                                                                                    <div className='procontnt'>
                                                                                        <p>{item.description}</p>
                                                                                    </div>
                                                                                    <Link className='links' onClick={() => handleShow(item)}>Read more....</Link>
                                                                                </div>
                                                                            </div>
                                                                        </Col>
                                                                    ))}
                                                                </Row>
                                                            </div>
                                                        </Tab>
                                                    )}
                                                    {/* <Tab eventKey="qa" title="Q&A">
                                                        <h4>Questions & Answers</h4>
                                                        <p>No questions yet. Be the first to ask!</p>
                                                    </Tab> */}
                                                </Tabs>
                                            </div>
                                        </div>
                                    </Container>
                                </div>
                            </section>

                            {relatedPro?.length > 0 && (
                                <section id='relatedproducts' className="related-products-section">
                                    <div className='relatedproducts-block'>
                                        <Container>
                                            <div className='pagetitles'>
                                                <h2 className="sec-title mb-0">YOU MAY <span className="text-teal">ALSO LIKE</span></h2>
                                            </div>
                                            <div className='relatedproducts-box'>
                                                <Swiper
                                                    modules={[Navigation, Pagination, Scrollbar, A11y]}
                                                    spaceBetween={0}
                                                    slidesPerView={5}
                                                    navigation
                                                    pagination={{ clickable: true }}
                                                    scrollbar={{ draggable: true }}
                                                    breakpoints={{
                                                        1200: { slidesPerView: 5 },
                                                        1024: { slidesPerView: 4 },
                                                        768: { slidesPerView: 3 },
                                                        640: { slidesPerView: 2 },
                                                        401: { slidesPerView: 2 },
                                                        300: { slidesPerView: 2 },
                                                    }}
                                                >
                                                    {relatedPro.map((item, index) => (
                                                        <SwiperSlide key={`thumb-${index}`}>
                                                            <ProductCard
                                                                PlanName={item?.eligible_plan_name}
                                                                PlanContent={item?.thumbnail_description}
                                                                Name={item.name}
                                                                SkuID={item.sku_id}
                                                                ImgUrl={item.media_list[0].media_url}
                                                                Offer={item.discount_per}
                                                                Price={item.price}
                                                                OldPrice={item.actual_price}
                                                                ProductSlug={item.slug}
                                                                ProductLabel={item?.product_label}
                                                                Quantitys={item.quantity}
                                                                Brands={item?.brands?.name}
                                                                Model={item?.model?.name}
                                                                Cart={cart}
                                                                Wishlist={wishlist}
                                                                ToggleWishlist={toggleWishlist}
                                                                addToCart={addToCart}
                                                            />
                                                        </SwiperSlide>
                                                    ))}
                                                </Swiper>
                                            </div>
                                        </Container>
                                    </div>
                                </section>
                            )}
                        </>
                    }
                </>
            )}

            <Footer toast={toast} />

            {isLoadings && <Loader />}

            <Modal id="testi" show={show} onHide={handleClose} className="review-modal">
                <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div id='popups' className='reviewsboxs'>
                        <div className='reviewshed'>
                            <div className='userio'>
                                <img src={review.image_url} alt='' title='' />
                            </div>
                            <div className='username'>
                                <h4>{review.customer_name}</h4>
                                <p>{review.review_date}</p>
                            </div>
                        </div>
                        <div className="reviewsbody">
                            <div className='rating'>
                                {[...Array(5)].map((_, i) => {
                                    const starVal = i + 1;
                                    if (starVal <= Math.floor(review.rating)) return <FaStar key={i} />;
                                    if (starVal === Math.ceil(review.rating) && review.rating % 1 !== 0) return <FaStarHalfAlt key={i} />;
                                    return <FaStar key={i} style={{ color: '#ccc' }} />;
                                })}
                            </div>
                            <div className='procontnts'>
                                <p>{review.description}</p>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default ProductDetail;